export default function openModal(modal){
    if(modal == 'client'){
        console.log('will try to open client modal')
        $('#client-modal').modal('toggle')
        $('.select2').select2();
    } else {
        console.log('dont actually know')
    }
}